import React from 'react';
import {
  Flex,
  Icon,
  Heading,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  useColorModeValue,
  VStack,
  Text,
  HStack,
  Box
} from '@chakra-ui/react';
import { FaWhatsapp, FaUsers, FaChevronDown, FaSync } from 'react-icons/fa';

/**
 * Header component for WhatsApp chat interface
 * Redesigned to place chat selector on separate row and handle long group names
 */
const ChatHeader = ({ 
  chatTarget, 
  setChatTarget, 
  whatsappGroupName, 
  formattedPhone, 
  whatsappGroup, 
  fetchChatHistory, 
  isRefreshing 
}) => {
  const headerBg = useColorModeValue('#123d2a', '#2f3436');
  const headerText = useColorModeValue('white', 'white');
  const borderColor = useColorModeValue('green.200', 'green.700');
  const secondaryBg = useColorModeValue('#1a4e36', '#394142');

  return (
    <VStack 
      spacing={0} 
      align="stretch" 
      borderTopRadius="md"
      borderBottomWidth="1px"
      borderColor={borderColor}
    >
      {/* Main header with title */}
      <Flex 
        p={3} 
        bg={headerBg} 
        color={headerText} 
        alignItems="center"
        borderTopRadius="md"
      >
        <Icon as={chatTarget === 'personal' ? FaWhatsapp : FaUsers} boxSize={5} mr={2} />
                        <Box flex={1} overflow="hidden">
          <Heading size={chatTarget === 'group' && whatsappGroupName && whatsappGroupName.length > 15 ? "xs" : "sm"} isTruncated>
            {chatTarget === 'personal' ? 'WhatsApp Chat' : (whatsappGroupName || 'Group Chat')}
          </Heading>
        </Box>
        
        {/* Refresh button */}
        <IconButton
          icon={<FaSync />}
          aria-label="Refresh chat"
          size="sm"
          variant="ghost"
          color={headerText}
          onClick={() => fetchChatHistory(true)}
          isLoading={isRefreshing}
          _hover={{ bg: 'whiteAlpha.200' }}
        />
      </Flex>
      
      {/* Chat type selector row */}
      {formattedPhone && whatsappGroup && (
        <HStack 
          p={2} 
          bg={secondaryBg} 
          color={headerText} 
          spacing={2}
          justify="center"
        >
          <Button
            size="xs"
            variant={chatTarget === 'personal' ? "solid" : "ghost"}
            colorScheme={chatTarget === 'personal' ? "green" : "whiteAlpha"}
            onClick={() => setChatTarget('personal')}
            leftIcon={<FaWhatsapp />}
          >
            Personal Chat
          </Button>
          <Button
            size="xs"
            variant={chatTarget === 'group' ? "solid" : "ghost"}
            colorScheme={chatTarget === 'group' ? "green" : "whiteAlpha"}
            onClick={() => setChatTarget('group')}
            leftIcon={<FaUsers />}
          >
            Group Chat
          </Button>
        </HStack>
      )}
    </VStack>
  );
};

export default ChatHeader;
